import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import "../MainBox.css";
import "../../Landing_Page/Landing.css";

export default function NotesPopUpUS(props) {
    const [isProcessing, setIsProcessing] = useState(true);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');
    const [canEdit, setCanEdit] = useState(false);
    const [notesData, setNotesData] = useState({
        noteID: 0,
        isbn: props.ISBNId,
        status: "Active", isPriority: false, visibility: "Public", note: "", creator: props.upn, Action: ''
    })

    useEffect(() => {
        loadNotes();
    }, [props]);

    const loadNotes = async () => {
        try {
            setIsProcessing(true); setError(null); setMessage('Loading Notes...');
            if (!props.noteID || props.noteID <= 0) {
                setNotesData({
                    noteID: 0,
                    isbn: props.ISBNId,
                    status: "Active", isPriority: false, visibility: "Public", note: "", creator: props.upn, Action: ''
                });
                if (props.isEditable)
                    setCanEdit(true);
                else
                    setCanEdit(false);
                return;
            }
            const data = await apiHelper.inventoryPostCall("getNotes", { value: props.noteID });
            if (data != undefined && data != null) {
                setNotesData(data);
                setCanEdit(props.upn.toLowerCase().trim() === data.creator.toLowerCase().trim() && props.isEditable)
            }
        } catch ({ name, message }) {
            console.error('Failed loadNotes', name, message);
            setError(`Failed to load note with error ${message}`)
        } finally {
            setIsProcessing(false);
            setMessage('');
        }
    }




    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }

    const handlFieldChange = (name, value) => {
        setNotesData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const saveNotes = async (event) => {
        const { value } = event.target;
        try {
            setIsProcessing(true); setError(null); setMessage(null);
            let entity = notesData;
            entity.Action = value;
            entity.creator = props.upn;
            entity.isbn = props.ISBNId;
            const data = await apiHelper.inventoryPostCall("createNotes", entity, true);
            props.onSave(true);
            if (value == 'D') {
                setMessage("Note deleted successfully.");
            }
            setMessage("Note saved successfully.");
            props.onClose();
        } catch ({ name, message }) {
            console.error('Failed SaveNotes', name, message);
            const operation = value == 'D' ? 'delete' : value == 'I' ? 'save new' : 'update';
            setError(`Failed to ${operation} note with error ${message}`)
        } finally {
            setIsProcessing(true);
        }
    }


    return (
        <>{props?.open ? (
            <div className="popup-overlay container-fluid">
                <div className="popup" style={{ overflowY: "auto", backgroundColor: "#F5F5F6" }}>{/*<button className="ISBNClose" onClick={props?.onClose}>X</button>*/}
                    <p style={{ paddingLeft: "15px" }} className="mb-0  fw-bold fs-7 pb-1">Update or View Note<button className="popup-close-btn" onClick={props?.onClose}></button></p>
                    <hr style={{ height: "2px", borderWidth: "0", color: "gray", backgroundColor: "grey", margin: "0" }} />

                    <div className="note-popup-content"  >
                        <Row>
                            <Col className="flex-grow-0 mt-1">
                                <table className="input-table">
                                    <tr>
                                        <th>Create Date</th>
                                    </tr>
                                    <tr>
                                        <td className="pl-1">
                                            {showFormatDate(notesData.createDate) || showFormatDate(Date())}
                                        </td>
                                    </tr>
                                </table>
                            </Col>
                            <Col className="flex-grow-0 mt-1">
                                <table className="input-table">
                                    <tr>
                                        <th>Author</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            {notesData.userName || ' '}
                                        </td>
                                    </tr>
                                </table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label>
                                    <input id='visibility' type="radio" name="visibility" id="visibility"
                                        value="Public"
                                        checked={notesData.visibility.toLowerCase() == "public"}
                                        disabled={!canEdit}
                                        onChange={(e) => handlFieldChange('visibility', e.target.value)} />Public</label><br />
                                <label>
                                    <input id='visibility' type="radio" name="visibility" id="visibility"
                                        value="Private"
                                        disabled={!canEdit}
                                        checked={notesData.visibility.toLowerCase() == "private"}
                                        onChange={(e) => handlFieldChange('visibility', e.target.value)} />Private</label>
                            </Col>
                            <Col>
                                <label>
                                    <input id='status' type="radio" name="status" id="status"
                                        value="Active"
                                        disabled={!canEdit}
                                        checked={notesData.status.toLowerCase() == "active"}
                                        onChange={(e) => handlFieldChange('status', e.target.value)} />Active</label><br />
                                <label>
                                    <input id='status' type="radio" name="status" id="status"
                                        value="Inactive"
                                        checked={notesData.status.toLowerCase() == "inactive"}
                                        disabled={!canEdit}
                                        onChange={(e) => { handlFieldChange('status', e.target.value); handlFieldChange('isPriority', false); }} />InActive</label>
                            </Col>
                            <Col>
                                <label>
                                    <input type="radio" name="isPriority" id="isPriority"
                                        value="Priority"
                                        disabled={!canEdit}
                                        checked={notesData.isPriority}
                                        onChange={(e) => handlFieldChange('isPriority', true)} />Priority</label><br />
                                <label>
                                    <input type="radio" name="isPriority" id="isPriority"
                                        value="Non-Priority"
                                        disabled={!canEdit}
                                        checked={!notesData.isPriority}
                                        onChange={(e) => handlFieldChange('isPriority', false)} />Non-Priority
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <table className="note-area">
                                <tr>
                                    <th>Note</th>
                                </tr>
                                <tr>
                                    <td>
                                        <textarea id="inputText"
                                            value={notesData.note}
                                            readOnly={!canEdit}
                                            maxLength={2000}
                                            style={{ padding: "6px"} }
                                            onChange={(e) => handlFieldChange("note", document.getElementById('inputText').value)}></textarea>
                                    </td>
                                </tr>
                            </table>
                        </Row>
                        <Row className="action-bar alerts" style={{ marginLeft: "auto", marginRight: "auto", display: "grid" }}>
                            <div >
                                {error && <span className="error">{error}</span>}
                                {message && <span className="success">{message}</span>}
                            </div>
                        </Row>
                        <Row className="action-bar" style={{ marginLeft: "auto", marginRight: "auto", display: "grid" }}>
                            <div >
                                <button className="ISBNSubmit note-button-width ml-1"
                                    value={!props.noteID || props.noteID <= 0 ? 'I' : 'U'}
                                    disabled={!canEdit || isProcessing || !notesData.note || notesData.note?.trim().length == 0}
                                    onClick={saveNotes}>Save</button>
                                <button className="ISBNSubmit note-button-width ml-5" value='D'
                                    disabled={!canEdit || isProcessing || !props.noteID || props.noteID <= 0}
                                    onClick={saveNotes}>Delete</button>
                            </div>
                        </Row>
                        
                    </div>
                </div>
            </div>
        )
            :
            <></>}
        </>
    )
}